"use strict";
exports.__esModule = true;
var ApolloLinkNetworkStatus_1 = require("./ApolloLinkNetworkStatus");
var Dispatcher_1 = require("./Dispatcher");
var useApolloNetworkStatus_1 = require("./useApolloNetworkStatus");
var useApolloNetworkStatusReducer_1 = require("./useApolloNetworkStatusReducer");
function createNetworkStatusNotifier() {
    var dispatcher = new Dispatcher_1["default"]();
    var link = new ApolloLinkNetworkStatus_1["default"](dispatcher);
    function useConfiguredApolloNetworkStatus(options) {
        return useApolloNetworkStatus_1["default"](dispatcher, options);
    }
    function useConfiguredApolloNetworkStatusReducer(reducer, initialState) {
        return useApolloNetworkStatusReducer_1["default"](dispatcher, reducer, initialState);
    }
    return {
        link: link,
        useApolloNetworkStatus: useConfiguredApolloNetworkStatus,
        useApolloNetworkStatusReducer: useConfiguredApolloNetworkStatusReducer
    };
}
exports["default"] = createNetworkStatusNotifier;
